import React from 'react'
import BaseUISellerStoresView from 'xui/modules/storeSeller/BaseUISellerStoresView'

class SellerStoresView extends BaseUISellerStoresView {
  static displayName = 'SellerStores'
}

export default SellerStoresView
